import { FC, useEffect, useMemo, useState } from "react";
import PatientDetailsComponent from "../../EMR/components/layouts/PatientDetailsComponent";
import { useMutation } from "react-query";
import { getAuditLog } from "../services";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import CustomTableBody from "../../utilis/component/CustomTableBody";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { EmrDataProvider } from "../../EMR";
import { formatLocalDateTime } from "../../utilis/methods/localDateTime";
const AuditLog: FC = () => {
  const { encounterId } = useParams();
  const navigate = useNavigate();
  const { mutate: fetchAuditLog, data, isLoading } = useMutation(getAuditLog);
  const [pageControl, stPageControl] = useState({
    first: 0,
    last: 12,
  });
  const [pagination, setPagination] = useState({
    page: 0,
    size: 12,
  });
  const listData = useMemo(() => {
    if (data?.response?.length) {
      return [...data?.response].slice(pageControl.first, pageControl.last);
    } else {
      return [];
    }
  }, [data?.response, pagination]);

  const handleChangePage = (_: unknown, page: number) => {
    if (pagination.page < page) {
      stPageControl((prev) => ({
        first: prev.first + pagination.size,
        last: prev.last + pagination.size,
      }));
    } else {
      stPageControl((prev) => ({
        first: prev.first - pagination.size,
        last: prev.last - pagination.size,
      }));
    }
    setPagination((prev: any) => ({
      ...prev,
      page,
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const size = parseInt(event.target.value, 10);
    stPageControl({
      first: 0,
      last: size,
    });
    setPagination({
      page: 0,
      size,
    });
  };

  useEffect(() => {
    fetchAuditLog(encounterId as string);
  }, []);
  return (
    <EmrDataProvider>
      <div className="py-3 px-2 flex flex-col gap-3">
        <div className="p-2 border-b flex justify-between items-center">
          <Typography fontSize={"1rem"} fontWeight={600}>
            Audit log
          </Typography>
          <Button
            variant="text"
            color="error"
            startIcon={<ArrowBackIcon />}
            onClick={() => {
              navigate(-1);
            }}
          >
            back
          </Button>
        </div>
        <PatientDetailsComponent />
        <TableContainer component={Paper} className="">
          <Table size="small" aria-label="simple table">
            <TableHead
              className="sticky top-0 z-[999]"
              sx={(theme) => ({
                backgroundColor: theme.palette.background.paper,
              })}
            >
              <TableRow>
                {headings.map((heading, index) => (
                  <TableCell key={`auditLogs${index}`}>
                    <strong>{heading}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <CustomTableBody
              alert={"No record"}
              dataLoading={isLoading}
              isData={Boolean(listData?.length)}
              totalSpan={{ row: 10, col: headings.length }}
            >
              {listData?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {pageControl.first + index + 1}
                  </TableCell>
                  <TableCell>{row.actionType}</TableCell>
                  <TableCell>{row.logType}</TableCell>
                  <TableCell>{row.newValue}</TableCell>
                  <TableCell>{row.oldValue}</TableCell>
                  <TableCell>{row.fieldName}</TableCell>
                  <TableCell>
                    {formatLocalDateTime(row.timeStamp)}
                  </TableCell>
                  <TableCell>{row.user}</TableCell>
                </TableRow>
              ))}
            </CustomTableBody>
          </Table>
          <div className="border-t">
            <TablePagination
              rowsPerPageOptions={[5, 12, 25, 50]}
              component="div"
              count={data?.response?.length || 0}
              rowsPerPage={pagination.size}
              page={pagination.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </TableContainer>
      </div>
    </EmrDataProvider>
  );
};

export default AuditLog;
const headings = [
  "Slno",
  "Action type",
  "Log type",
  "New value",
  "Old value",
  "Affected field",
  "Time",
  "Modified by",
];
